import React, { Component } from "react";
import { css } from "react-emotion";

const image = css`
  width: 100%;
  object-fit: cover;
  position: relative;
`;

const container = css`
  width: 100%;
  max-height: 218px;
  position: relative;
`;

const businessName = css`
  color: white;
`;

const businessNameContainer = css`
  width: 100%;
  position: absolute;
  bottom: 0;
  background: rgba(112, 112, 112, 0.5);
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: center;
`;

class ImageBanner extends Component {
  render() {
    let { src, name } = this.props;

    // default image
    src = src
      ? src
      : "https://mobile360-assets.s3.us-east-2.amazonaws.com/image-not-found.png";
    return (
      <div className={container}>
        <img className={image} src={src} alt={src} />
        <div className={businessNameContainer}>
          <p className={businessName}>{name}</p>
        </div>
      </div>
    );
  }
}

export default ImageBanner;
